import {Typography} from "@mui/material"
import {forwardRef} from "react"

const FormattedToolTip  = forwardRef(function FormattedToolTip({title, description}, ref) {
	return (
		<div ref={ref}>
			<Typography variant={"body1"}>{title}</Typography>
			<Typography variant={"caption"}>{description}</Typography>
		</div>
	)
})

export default FormattedToolTip